export const certifications = [
  {
    title: "Cisco Networking Academy",
    issuer: "",
    items: [
      "Python Essentials 1 & 2",
      "Introduction to Cybersecurity",
      "CCNA: Introduction to Networks",
      "CCNA: Switching, Routing and Wireless Essentials",
      "CCNA: Enterprise Networking, Security and Automation"
    ]
  },
  {
    title: "NPTEL",
    issuer: "",
    items: [
      "Leadership" ,
      " Public Speaking"
    ]
  }
];